import { useDispatch } from "react-redux";
import { login } from "../../redux/authSlice.js";

import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import api from "../../config/axiosConfig.js";

const SwitchContingencia = ({ MiEmpresa, formData = null }) => {
  const { id: id_empresa } = MiEmpresa; // ✅ Obtener `id_empresa` del estado global
  const dispatch = useDispatch();

  const modoContingencia = MiEmpresa.modoContingencia;
  const url_api = modoContingencia ? `/dte/contingencia/cerrar` : `/dte/contingencia/abrir`;
  const payload = modoContingencia ? { id_empresa } : { ...formData, id_empresa };

  const mutation = useMutation({
    mutationFn: async () => {
      const res = await api.post(url_api, payload);
      return res.data;
    },
    onSuccess: (data) => {
      console.log("actualizando empresas del usuario");
      console.log(data);

      const user = JSON.parse(localStorage.getItem("user"));
      const token = localStorage.getItem("token");
      dispatch(login({ user, token, empresas: data.empresas }));
      toast.success(modoContingencia ? "Modo Contingencia desactivada" : "Modo Contingencia activada");
    },
    onError: (err) => {
      const { error, mensaje } = err;
      toast.error(
        <div>
          <strong>{mensaje}</strong>
          {error?.observaciones.length > 0 && (
            <ul style={{ marginTop: "0.5rem" }}>
              {error?.observaciones.map((obs, i) => (
                <li key={i}>{obs}</li>
              ))}
            </ul>
          )}
        </div>
      );
    },
  });

  const buttonText = modoContingencia ? "Desactivar Contingencia" : "Activar Contingencia";
  return (
    <button
      className={modoContingencia ? "btn-lg btn btn-lg btn-blue" : "btn btn-lg btn-red"}
      onClick={() => mutation.mutate()}
      disabled={mutation.isPending}
    >
      {mutation.isPending ? "Cargando..." : buttonText}
    </button>
  );
};

export default SwitchContingencia;
